import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import {
  ApplicationAppEntityApplicationRead,
  TreeToRemoveAppEntityTreeToRemoveRead,
  TreeToRemoveAppEntityTreeToRemoveWrite,
  TreeToRemoveService
} from '../openapi';

@Injectable({
  providedIn: 'root'
})
export class TreeToRemoveCommonService {
  constructor(
    private treeToRemoveService: TreeToRemoveService
  ) {
  }

  public updateTreesToRemove(items: TreeToRemoveAppEntityTreeToRemoveWrite[], application: ApplicationAppEntityApplicationRead): Observable<TreeToRemoveAppEntityTreeToRemoveRead[]> {
    const deleteRequests: Observable<any>[] = application.treesToRemove?.map(v => v.id || '').map(v => this.treeToRemoveService.deleteTreeToRemoveTreeToRemoveItem({ id: v })) as Observable<any>[];
    return (deleteRequests.length ? forkJoin(deleteRequests) : of([])).pipe(
      switchMap(() => {
        return items.length ? forkJoin(items.map(treeToRemove => this.treeToRemoveService.postTreeToRemoveTreeToRemoveCollection({
              treeToRemove: {
                ...treeToRemove,
                application: application.uuid || ''
              }
            })
          )
        ) : of([]);
      })
    );
  }
}
